"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
const HelmetTitle = ({ title, description }) => {
    return (react_1.default.createElement(react_helmet_1.Helmet, null,
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("meta", { content: description, name: "description" }),
        react_1.default.createElement("meta", { content: title, property: "og:title" }),
        react_1.default.createElement("meta", { content: description, property: "og:description" }),
        react_1.default.createElement("meta", { content: "website", property: "og:type" }),
        react_1.default.createElement("meta", { content: "/ORIGYN-logo-200.png", property: "og:image" }),
        react_1.default.createElement("meta", { content: title, property: "twitter:title" }),
        react_1.default.createElement("meta", { content: "summary_large_image", name: "twitter:card" }),
        react_1.default.createElement("meta", { content: description, property: "twitter:description" }),
        react_1.default.createElement("meta", { content: "/ORIGYN-logo-200.png", property: "twitter:image" }),
        react_1.default.createElement("link", { href: "/sitemap.xml", rel: "sitemap", type: "application/xml" }),
        window.location.host.includes("local") ? "" :
            react_1.default.createElement("script", { defer: true, "data-domain": window.location.host, src: "https://stats.origyn.ch/js/script.js" })));
};
exports.default = HelmetTitle;
